import { getWhitelabel } from 'web-app/shared/white-labeling-helpers';
import { hasValue } from '@famly/stat_ts-utils_has-value';
import NewLookTheme from './new-look';
import EspiraTheme from './espira';
import KidoTheme from './kido';
import GrandirUKTheme from './grandiruk';
import NuffieldHealthTheme from './nuffieldhealth';
import BrightHorizonsTheme from './bright-horizons';
import KindredTheme from './kindred';
import NFamilyClubTheme from './nfamilyclub';
import KinderzimmerUKTheme from './kinderzimmeruk';
import CpcTreehouseTheme from './cpc-treehouse';
import CpcOrchardsTheme from './cpc-orchards';
import BusybeesTheme from './busybees';
import BBMontessoriTheme from './bbmontessori';
import BBOdysseyTheme from './bbodyssey';
import BaseTheme from './base';
import { TwizzleTopsTheme } from './twizzle-tops';
import { ChildbaseTheme } from './childbase';
import SeymourHouseTheme from './seymourhouse';
import TheOldStationNurseryTheme from './theoldstationnursery';
import NFamilySchoolTheme from './nfamilyschool';
import WhitelabelTestTheme from './whitelabeltest';
export const currentTheme = () => {
    const whitelabel = getWhitelabel();
    switch (whitelabel) {
        case 'espira':
            return EspiraTheme;
        case 'kido':
            return KidoTheme;
        case 'brighthorizons':
            return BrightHorizonsTheme;
        case 'kindred':
            return KindredTheme;
        case 'nfamilyclub':
            return NFamilyClubTheme;
        case 'grandiruk':
            return GrandirUKTheme;
        case 'nuffieldhealth':
            return NuffieldHealthTheme;
        case 'kinderzimmeruk':
            return KinderzimmerUKTheme;
        case 'cpctreehouse':
            return CpcTreehouseTheme;
        case 'cpcorchards':
            return CpcOrchardsTheme;
        case 'busybees':
            return BusybeesTheme;
        case 'bbmontessori':
            return BBMontessoriTheme;
        case 'bbodyssey':
            return BBOdysseyTheme;
        case 'twizzletops':
            return TwizzleTopsTheme;
        case 'childbase':
            return ChildbaseTheme;
        case 'seymourhouse':
            return SeymourHouseTheme;
        case 'theoldstationnursery':
            return TheOldStationNurseryTheme;
        case 'nfamilyschool':
            return NFamilySchoolTheme;
        case 'whitelabeltest':
            return WhitelabelTestTheme;
        case 'famly':
        case null:
            return NewLookTheme;
        default:
            return BaseTheme;
    }
};
export const getCurrentModernFamlyTheme = () => {
    const whitelabel = getWhitelabel();
    const theme = currentTheme();
    if (!hasValue(whitelabel)) {
        return NewLookTheme.mf;
    }
    return theme.mf;
};
export default currentTheme;
export { NewLookTheme };
